import { render, staticRenderFns } from "./DashboardScaleScores.vue?vue&type=template&id=be4aede6&scoped=true&"
import script from "./DashboardScaleScores.vue?vue&type=script&lang=js&"
export * from "./DashboardScaleScores.vue?vue&type=script&lang=js&"
import style0 from "./DashboardScaleScores.vue?vue&type=style&index=0&id=be4aede6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be4aede6",
  null
  
)

export default component.exports